window.static_book = window.static_book || {};

const fetchWithTimeout = async (resource, options) => {
    const {timeout = 8000} = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(resource, {
        ...options,
        signal: controller.signal,
    });
    clearTimeout(id);
    return response;
};

const initSelector = (id) => {
    document.querySelectorAll(`.book-explorer__item`).forEach((el) => {
        el.style.display = 'none';
    });
    resetSelectorBar();
};

const setSelectors = (selector) => {
    if (selector === 'book-collection') {
        document.querySelectorAll('.book-collection').forEach((el) => (el.style.display = 'inline-block'));
    }
    else {
        document.querySelectorAll('.book-collection').forEach((el) => (el.style.display = 'none'));
    }
};

const populateResults = (activeId, activeHandle, activeTitle, data) => {
    document.querySelector('.book-explorer__wrapper').style.minHeight = '450px';
    let i = 0;
    document.getElementById('no-results').style.display = 'none';
    data.forEach((obj) => {
        document.getElementById(`explorer__url--${i}`).setAttribute('href', `/products/${obj.handle}`);
        document.getElementById(`explorer__img--${i}`).setAttribute('src', obj.image);
        document.getElementById(`explorer__title--${i}`).innerText = obj.title;
        document.getElementById(`explorer__blurb--${i}`).innerText = obj.blurb;
        document.getElementById(`explorer__btn--${i}`).dataset.variant = obj.variant_id;
        document.querySelector(`.book-explorer__result--${i}`).style.display =
            'inline-block';
        i++;
    });
    document.getElementById('default-title').style.display = 'none';
    document.getElementById('selected-option').innerText = activeTitle;
    scrollToTop();
};

const initOptions = () => {
    const existingId = localStorage.getItem('rbb-id');
    const existingHandle = localStorage.getItem('rbb-handle');
    const existingTitle = localStorage.getItem('rbb-title');
    const existingSelector = localStorage.getItem('rbb-selector');
    const resultSet = localStorage.getItem('rbb-results');
    if (existingSelector) {
        setSelectors(existingSelector);
    }
    if (existingId) {
        initSelector(existingId);
        if (resultSet) {
            const results = JSON.parse(resultSet);
            populateResults(existingId, existingHandle, existingTitle, results);
            document.getElementById('no-results').style.display = 'none';
        }
        else {
            console.log('nothing 1');
            document.getElementById('no-results').style.display = 'block';
        }
    }
};

const resetSelectorBar = () => {
    document.querySelectorAll(`.book-explorer__item`).forEach((el) => {
        el.classList.remove('active-selector');
    });
    document.getElementById('selected-option').innerText = '';
    document.getElementById('default-title').style.display = 'block';
    document.querySelector('.book-explorer__wrapper').style.minHeight = '450px';
};

const hideResults = () => {
    document.querySelectorAll('.book-explorer__results').forEach((el) => (el.style.display = 'none'));
    document.querySelector('.book-explorer__wrapper').style.minHeight = 'unset';
};

document.addEventListener('page:loaded', function() {
    document.querySelectorAll('.book-explorer__link').forEach((element) => {
        element.addEventListener('click', async (event) => {
            event.preventDefault();
            document.getElementById('explorer-reset').disabled = true;
            document.getElementById('book-explorer__grid--after').style.display = 'flex';
            const activeId = element.dataset.id;
            const activeHandle = element.dataset.handle;
            const activeTitle = element.dataset.title;
            localStorage.setItem('rbb-id', activeId);
            localStorage.setItem('rbb-handle', activeHandle);
            localStorage.setItem('rbb-title', activeTitle);
            //hide the other selectors
            initSelector(activeId);
            const url = `/apps/rbbr/api/explorer/${activeId}`;
            await fetchWithTimeout(url, {timeout: 6000}).then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Error fetching books');
            }).then((data) => {
                const books = data?.books;
                if (books?.length) {
                    localStorage.setItem('rbb-results', JSON.stringify(books));
                    populateResults(activeId, activeHandle, activeTitle, books);
                }
                else {
                    hideResults();
                    document.getElementById('no-results').innerHTML =
                        '<h3>Sorry - we don\'t currently have any products matching your selection - please try again!</h3>';
                    document.getElementById('no-results').style.display = 'block';
                }
                document.getElementById('book-explorer__grid--after').style.display = 'none';
                document.getElementById('explorer-reset').disabled = false;
            }).catch((error) => {
                console.log(error);
                hideResults();
                document.getElementById('no-results').innerHTML =
                    '<h3>Oops - we\'re having trouble finding you a matching book - please try again!</h3>';
                document.getElementById('no-results').style.display = 'block';
                document.getElementById('book-explorer__grid--after').style.display = 'none';
                document.getElementById('explorer-reset').disabled = false;
            });
        });
    });

    document.getElementById('explorer-reset').addEventListener('click', (event) => {
        event.preventDefault();
        resetSelectorBar();
        document.querySelectorAll('.book-explorer__results').forEach((el) => (el.style.display = 'none'));
        document.getElementById('no-results').style.display = 'none';
        document.querySelectorAll('.book-collection').forEach((el) => (el.style.display = 'inline-block'));
        document.getElementById('selected-option').innerText = '';
        localStorage.removeItem('rbb-id');
        localStorage.removeItem('rbb-selector');
        localStorage.removeItem('rbb-results');
        scrollToTop();
    });

    document.querySelectorAll('.book-explorer__selectors > .btn').forEach((el) => {
        el.addEventListener('click', (event) => {
            event.preventDefault();
            resetSelectorBar();
            localStorage.setItem('rbb-selector', el.dataset.id);
            localStorage.removeItem('rbb-id');
            localStorage.removeItem('rbb-results');
            document.querySelectorAll('.book-explorer__results').forEach((el) => el.style.display = 'none');
            document.getElementById('no-results').style.display = 'none';
            setSelectors(el.dataset.id);
        });
    });

    document.querySelectorAll('.explorer__add-button').forEach(el=>{
        el.addEventListener('click', addToCart);
    })

    initOptions();
});

const scrollToTop = () => {
    document.querySelector('.book-explorer__grid').scrollIntoView({behavior:'smooth'});
};

const addToCart = (evt) => {
    evt.preventDefault();
    console.log(evt);
    const button = evt.target;
    button.classList.add('btn--loading');
    const variant = button.dataset.variant;
    const items = [{
        id: variant,
        quantity: 1
    }];
    fetch('/cart/add.js', {
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        method: 'POST',
        body: JSON.stringify({
            items: items,
        })
    }).then(() => {
        button.classList.remove('btn--loading');
        document.dispatchEvent(new CustomEvent('cart:build'));
    });
};